import React from 'react'
import "./footer.scss"

const Footer = () => {
  return (
    <div className='footer_main'>
      Developed By &nbsp; 
      <a href="https://codebraininfotech.com/" target='blank'> CodeBrain Infotech</a>
    </div>
  );
}

export default Footer
